const links = $('.js-links-match a');

if (links.length) {
  const currentUrl = window.location.href;

  links.each(function() {
    const link = $(this);
    const href = link.attr('href');
    if (currentUrl == href) {
      link.addClass('is-current');
    }
  });
}

const tagLinks = $('.js-tag-links a');

if (tagLinks.length) {
  const currentPath = window.location.pathname;
  const $mobileCurrentTag = $('.js-current-tag');

  $mobileCurrentTag.on('click', function(event) {
    event.preventDefault();
    $(this).parent().toggleClass('is-active');
  });

  tagLinks.each(function() {
    const link = $(this);
    const href = link.attr('href');
    
    if (currentPath == href) {
      const text = link.text();
      $mobileCurrentTag.text(text);
      link.parent().addClass('is-current');
    }
  });
}
